import { useEffect, useState, type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

interface AdminRouteProps {
  children: ReactNode;
}

const AdminRoute = ({ children }: AdminRouteProps) => {
  const [checking, setChecking] = useState(true);
  const [authed, setAuthed] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let active = true;

    const evaluate = async (session: { user: { id: string } } | null) => {
      if (!session) {
        if (!active) return;
        setAuthed(false);
        setIsAdmin(false);
        setChecking(false);
        return;
      }
      const { data, error } = await supabase.rpc("has_role", {
        _user_id: session.user.id,
        _role: "admin",
      });
      if (!active) return;
      setAuthed(true);
      setIsAdmin(!error && data === true);
      setChecking(false);
    };

    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      evaluate(session);
    });

    supabase.auth.getSession().then(({ data: { session } }) => {
      evaluate(session);
    });

    return () => {
      active = false;
      sub.subscription.unsubscribe();
    };
  }, []);

  if (checking) {
    return <div className="min-h-screen bg-background" aria-hidden />;
  }

  if (!authed) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!isAdmin) {
    // Don't reveal the route exists
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
